module.exports = __webpack_public_path__ + "media/src/images/icons/pencil_24-13e57fd1ca17ca6852d092f9cd0233d5.svg";